import React, { useState, useEffect, useMemo, useRef } from 'react';
import throttle from 'lodash/throttle';
import styled from 'styled-components';

// Styled
import { StyledAutocomplete, StyledTextField } from '../../styles/matieralui/Form';
import { StyledCircularProgress } from '../../styles/matieralui/Progress';
import { StyledButton } from '../../styles/matieralui/Button';
import { Box } from '@mui/material';

const StyledNoOptionsButton = styled(StyledButton)`
    width: 100%;
`

export const Autocomplete = ({ loading = false, label, onSearch, onClose, options, onChange, optionLabelKey, value, noOptionsText, noOptionsTextAction, onEnter, helperText, renderOption }) => {

    const [open, setOpen] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const inputRef = useRef();

    // Capture Collab Removed
    // let loading = false;
    // if (onSearch) loading = open && options.length === 0;


    const search = useMemo(() => throttle((searchString) => { onSearch(searchString) }, 1000), [])


    // --------------------------------
    // Effects
    // --------------------------------

    useEffect(() => {
        if (!onSearch) return;
        search(inputValue)
    }, [inputValue])

    // On Selection
    const handleChange = (e, newValue) => {
        const input = inputRef.current.querySelector('input');
        onChange(newValue)
        if (input) input.blur();
    }

    // On Searching
    const handleInputChange = (e, newValue) => setInputValue(newValue);

    const keyPress = (e) => {
        if (!onEnter) return;

        // On Enter
        if (e.keyCode == 13) {
            onEnter(e.target.value);
            e.target.blur();
        }

    }


    // --------------------------------
    // Renderers
    // --------------------------------

    const renderInput = (params) => {
        return (
            <StyledTextField {...params}
                ref={inputRef}
                label={label}
                variant="outlined"
                fullWidth
                helperText={helperText}
                InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                        <React.Fragment>
                            {loading ? <StyledCircularProgress /> : null}
                            {params.InputProps.endAdornment}
                        </React.Fragment>
                    ),
                }}
            />
        )
    }

    const getOptionLabel = (option) => {
        if (!option[optionLabelKey]) return ''; // Merge to App Starter
        return option[optionLabelKey]
    }

    const handleOnClose = () => {
        if (onClose) {
            setOpen(false);
            onClose();
        } else {
            setOpen(false)
        }

    }

    const renderNoOptions = () => {
        //noOptionsTextAction
        if (noOptionsTextAction) return (<StyledNoOptionsButton onClick={() => noOptionsTextAction(inputValue)}>{noOptionsText}</StyledNoOptionsButton>);
        if (noOptionsText) return noOptionsText;
        return 'No Options';
    }

    const renderSuggestions = (props, option) => {

        if (renderOption) {
            return renderOption(props, option);
        }
        return (
            <Box component="li" {...props}>{option[optionLabelKey]}</Box>
        )

    }



    return (
        <StyledAutocomplete
            open={open}
            onOpen={() => setOpen(true)}
            onClose={handleOnClose}
            getOptionLabel={getOptionLabel}
            options={options}
            loading={loading}
            renderInput={renderInput}
            autoComplete
            includeInputInList
            filterSelectedOptions
            value={value}
            onChange={handleChange}
            onInputChange={handleInputChange}
            noOptionsText={renderNoOptions()}
            onKeyDown={keyPress}
            renderOption={renderSuggestions}
        />
    )
}